export enum ListElementEnum {
    Status = 1,
    Priority = 2,
    TaskGroup1 = 3,
    TaskGroup2 = 4,
    TaskGroup3 = 5,
    TaskGroup4 = 6,
    TaskGroup5 = 7,
    RootCause = 8,
    TaskTemplate = 9,
    PeriodType = 10,
    GraphType = 11,
    ClientComment = 12,
    HelpTypes = 13,
    FcGroupName = 14,
    FcWebFilterName = 15,
    EsoGroupName = 16,
    EsoWebFilterName = 17,
    UnitOfMeasureType = 18,
    YesNo = 19,
    TransactionGroupName = 20
}